// Shared emoji avatars for consistent display across components
export const AVATAR_EMOJIS = [
  "🦊",
  "🐼",
  "🦁",
  "🐯",
  "🐸",
  "🐵",
  "🦄",
  "🐲",
  "🦋",
  "🐙",
  "🦀",
  "🐳",
  "🦩",
  "🦚",
  "🦜",
  "🐧",
  "🐺",
  "🐻",
  "🐨",
  "🐰",
  "🐹",
  "🐭",
  "🐱",
  "🐶",
  "🦝",
  "🐮",
  "🐷",
  "🐔",
  "🐤",
  "🦆",
  "🦅",
  "🦉",
  "🐝",
  "🐛",
  "🐌",
  "🦎",
  "🐢",
  "🐍",
  "🦖",
  "🐊",
];

// Vibrant and distinct color palette for participants
export const AVATAR_COLORS = [
  "#00D9A6", // Emerald Green
  "#FF6B6B", // Coral Red
  "#4ECDC4", // Teal
  "#FFE66D", // Sunny Yellow
  "#A855F7", // Purple
  "#FF9F43", // Orange
  "#54A0FF", // Sky Blue
  "#FF6B9D", // Pink
  "#10B981", // Green
  "#F472B6", // Rose
  "#6366F1", // Indigo
  "#FBBF24", // Amber
  "#EC4899", // Magenta
  "#14B8A6", // Cyan
  "#8B5CF6", // Violet
  "#EF4444", // Red
  "#06B6D4", // Bright Cyan
  "#84CC16", // Lime
  "#F97316", // Bright Orange
  "#3B82F6", // Blue
  "#22D3EE", // Aqua
  "#A78BFA", // Light Purple
  "#FB7185", // Light Red
  "#34D399", // Light Green
];

// Get unique emoji based on index in participant list (ensures no duplicates)
export const getEmojiByIndex = (index: number): string => {
  return AVATAR_EMOJIS[index % AVATAR_EMOJIS.length];
};

// Get consistent emoji based on peerId hash (same across all clients)
export const getEmojiForPeerId = (peerId: string): string => {
  if (!peerId || peerId === "") {
    return AVATAR_EMOJIS[0]; // Default to first emoji
  }
  let hash = 0;
  for (let i = 0; i < peerId.length; i++) {
    hash = (hash << 5) - hash + peerId.charCodeAt(i);
    hash = hash & hash;
  }
  return AVATAR_EMOJIS[Math.abs(hash) % AVATAR_EMOJIS.length];
};

// Legacy: Get emoji based on name hash (may have duplicates)
export const getEmojiForName = (name: string): string => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = (hash << 5) - hash + name.charCodeAt(i);
    hash = hash & hash;
  }
  return AVATAR_EMOJIS[Math.abs(hash) % AVATAR_EMOJIS.length];
};

// Get unique color based on index in participant list
export const getColorByIndex = (index: number): string => {
  return AVATAR_COLORS[index % AVATAR_COLORS.length];
};

// Get consistent color based on peerId hash
export const getColorForPeerId = (peerId: string): string => {
  if (!peerId || peerId === "") {
    return AVATAR_COLORS[0]; // Default to first color
  }
  let hash = 0;
  for (let i = 0; i < peerId.length; i++) {
    hash = (hash << 5) - hash + peerId.charCodeAt(i);
    hash = hash & hash;
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
};
